import cn from 'classnames';
import {isEqual} from 'lodash-es';
import React, {useEffect} from 'react';

import {getSelectedMenusIdsByPathname} from 'components/@common/specific/new-side-menu/new-side-menu-utils';
import {SuspenseTrigger} from 'components/@common/technical/suspense-trigger';
import {DEFAULT_THEME} from 'shared/constants/layout';
import {useAppHistory} from 'shared/hooks/use-app-history';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {
    selectIsMenuOpen,
    selectMenuStructureObject,
    selectSelectedMenusIds,
} from 'store/slices/menu-slice';
import {menuSliceActions} from 'store/slices/menu-slice/menu-slice';

import {NewSideMenuBody} from './new-side-menu-body';
import {NewSideMenuExpand} from './new-side-menu-expand';
import {NewSideMenuFooter} from './new-side-menu-footer';
import {NewSideMenuItem} from './new-side-menu-item';

import './new-side-menu.less';

export const NewSideMenu = () => {
    const dispatch = useAppDispatch();
    const {
        setIsMenuOpen,
        setSelectedMenuItemsIds,
    } = menuSliceActions;

    const history = useAppHistory();

    const isMenuOpen = useAppSelector(selectIsMenuOpen);
    const selectedMenusIds = useAppSelector(selectSelectedMenusIds);
    const menuStructure = useAppSelector(selectMenuStructureObject);
    const {menuItems, rawMenuItems} = menuStructure;

    useEffect(() => {
        if (!isMenuOpen) {
            // устанавливает значения selectedMenusIds, основываясь на текущем местоположении history.location.pathname
            // на случай, когда пользователь покликал по пунктам меню, но так ничего и не выбрал,
            // или когда перешел в раздел через поиск, минуя иерархию,
            // или когда перешел в раздел по прямой ссылке
            const pathBasedSelectedMenusIds = getSelectedMenusIdsByPathname({
                menuStructure: rawMenuItems,
                pathname: history.location.pathname,
            });

            if (!isEqual(selectedMenusIds, pathBasedSelectedMenusIds)) {
                dispatch(setSelectedMenuItemsIds(pathBasedSelectedMenusIds));
            }
        }
    }, [rawMenuItems, isMenuOpen, selectedMenusIds, history.location.pathname]);

    if (!menuItems) return <SuspenseTrigger />;

    return (
        <>
            <div
                className={cn(
                    'cursor-pointer',
                    {
                        'new-side-menu__partner-logo': (
                            process.env.REACT_APP_THEME !== DEFAULT_THEME
                        ),
                        'new-side-menu__logo': (
                            process.env.REACT_APP_THEME === DEFAULT_THEME
                        ),
                    },
                )}
                onClick={() => {
                    history.push('/widgets');
                }}
            >

                <img
                    src={`${process.env.PUBLIC_URL}/logos/${process.env.REACT_APP_THEME}-light.svg`}
                    alt="Витрина налогового мониторинга."
                />
            </div>

            <div
                className={cn('new-side-menu')}
            >
                <div
                    className={cn('new-side-menu__curve')}
                />
                <NewSideMenuBody />
                <div className={cn('new-side-menu__content', {
                    'new-side-menu__content_open': isMenuOpen,
                })}
                >
                    <NewSideMenuExpand
                        onClick={() => {
                            dispatch(setIsMenuOpen(!isMenuOpen));
                        }}
                        isOpen={isMenuOpen}
                    />
                    {menuItems?.map(item => (
                        <NewSideMenuItem
                            key={item.id}
                            item={item}
                        />
                    ))}
                </div>
                <NewSideMenuFooter />
            </div>
            {isMenuOpen && (
                <div
                    className={cn('new-side-menu__dark-bg')}
                    onClick={() => {
                        dispatch(setIsMenuOpen(false));
                    }}
                />
            )}
        </>

    );
};
